import {
  Button as HeroButton,
  InputGroup as HeroInputGroup,
  Label as HeroLabel,
  TextField as HeroTextField,
} from "@heroui/react"
import type { ButtonHTMLAttributes, ReactNode } from "react"

type TextFieldProps = {
  children?: ReactNode
  className?: string
  defaultValue?: string
  fullWidth?: boolean
  isDisabled?: boolean
  isRequired?: boolean
  name?: string
  type?: string
  variant?: "primary" | "secondary"
}

type LabelProps = {
  children?: ReactNode
  className?: string
}

type InputGroupProps = {
  children?: ReactNode
  className?: string
  variant?: "primary" | "secondary"
}

type ButtonProps = {
  children?: ReactNode
  className?: string
  fullWidth?: boolean
  isIconOnly?: boolean
  isDisabled?: boolean
  isPending?: boolean
  size?: "sm" | "md" | "lg"
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"]
  variant?:
    | "primary"
    | "secondary"
    | "ghost"
    | "danger"
    | "danger-soft"
    | "outline"
    | "tertiary"
  "aria-label"?: string
  onPress?: () => void
}

export const TextField = HeroTextField as (
  props: TextFieldProps,
) => React.JSX.Element
export const Label = HeroLabel as (props: LabelProps) => React.JSX.Element
export const InputGroup = HeroInputGroup as typeof HeroInputGroup & {
  (props: InputGroupProps): React.JSX.Element
  Input: typeof HeroInputGroup.Input
}
export const Button = HeroButton as (props: ButtonProps) => React.JSX.Element

InputGroup.Input = HeroInputGroup.Input
InputGroup.Suffix = HeroInputGroup.Suffix
